import React from 'react'
import Menu from '@/components/ui/Menu'
import { ReactComponent as ConnectorIcon } from '@/assets/icons/connector.svg'
import Button from '@/components/ui/Buttons/Button'
import Typography from '@/components/ui/Typography'
import { Dropdown } from '@mui/base/Dropdown'
import { HeaderTrigger } from '@/components/ui/Menu/Trigger'
import { useQuery } from '@tanstack/react-query'
import { Connector, connectorsQueries } from '@/features/connectors'

export type ConnectorsMenuProps = {
  onSelect: (connector: Connector) => void
  onNewSelect: () => void
}

export const ConnectorsMenu = ({ onSelect, onNewSelect }: ConnectorsMenuProps) => {
  const query = useQuery(connectorsQueries.list())

  return (
    <Dropdown>
      <HeaderTrigger StartIcon={<ConnectorIcon />}>Connectors</HeaderTrigger>
      <Menu>
        <Menu.Body>
          {query.isLoading ? (
            <Typography>Loading</Typography>
          ) : (
            query.data?.map((connector) => (
              <Menu.Item key={connector.id} StartIcon={<ConnectorIcon />} onClick={() => onSelect(connector)}>
                {connector.name}
              </Menu.Item>
            ))
          )}
        </Menu.Body>
        <Menu.Footer>
          <Button color={'neutral'} variant={'outlined'} isStretched onClick={onNewSelect}>
            + Add new
          </Button>
        </Menu.Footer>
      </Menu>
    </Dropdown>
  )
}
